import React, { Component } from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner, Table } from "react-bootstrap";
import Crypt from '../lib/Crypt';
import swal from 'sweetalert';
import C from '../lib/Config';

export default class ReduceDosagePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chemoMedicineAdverseEffectXId: 0,
            reduceDosageReport: '',
            reduceDosageReportValue: '',
            reportParameterArr: [],
            chemoMedicineDosageListArr: [],
            chemoMedicineDosageId: '',
            chemoMedicineDosageValue: ''
        }; 
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        this.getAllAdverseEffectMaster();  
    }
    handleChange(event){
        if(event.target.name === 'reduceDosageChemo'){
            this.setState({chemoMedicineDosageId: event.target.value});
            this.setState({chemoMedicineDosageValue: event.target.options[event.target.selectedIndex].text});
        }
        if(event.target.name === 'reduceDosageReport'){
            this.setState({reduceDosageReport: event.target.value});
            this.setState({reduceDosageReportValue: event.target.options[event.target.selectedIndex].text});
        } 
    }
    // validateReduceDosage(){
    //     let formIsValid = true;
    //     let errors = {};
    //     if (this.state.reduceDosageChemo === "" || this.state.reduceDosageChemo === null) {
    //         errors["reduceDosageChemo"] = "Please enter first name";
    //         formIsValid = false;
    //     }
    //     if (this.state.reduceDosageReport === "" || this.state.reduceDosageReport === null) {
    //         errors["reduceDosageReport"] = "Please select schedule for doctor visit";
    //         formIsValid = false;
    //     } 
    //     this.setState({protocol: errors });
    //     return formIsValid;
    // }
    saveReduceDosage(event){
        let data = { 
            chemoMedicineAdverseEffectXId: this.state.chemoMedicineAdverseEffectXId,
            reduceDosageReportID: this.state.reduceDosageReport,
            reduceDosageReportValues: this.state.reduceDosageReportValue,
            chemoMedicineDosageID: this.state.chemoMedicineDosageId,
            chemoMedicineDosageValue: this.state.chemoMedicineDosageValue,
        }
        this.props.saveReduceDosageTable(data);  
    }
    getReduceDosageDetail(chemoDoseageList) {
        console.log("medicineArr : " + JSON.stringify(chemoDoseageList));
        this.setState({ chemoMedicineDosageListArr: chemoDoseageList });  
    }
    getAllAdverseEffectMaster() {
        fetch(C.getUrl() + '/adverseEffectMaster/getAllAdverseEffectMaster')
        .then(res => res.json())
        .then(res => {
            if (!res || !res.message) return;
            let resObj = JSON.parse(res.message);
            if (!Array.isArray(resObj)) return;
            var arr = [];
            resObj.forEach(function (d) {
                arr.push({ id: d.selectionId, name: d.selectionValue });
            });
            this.setState({ reportParameterArr: arr });
        })
        .catch(err => {
            console.error("Error fetching adverse effects: " + err);
        });
    }
    
    render() {
        const { showReduceDosagePopup, closeModal} = this.props;
        const closePreviewModal = () => {
            closeModal();
        }
        const { reportParameterArr, chemoMedicineDosageListArr } = this.state;
        return (
            <div>
                <Modal id="report" show={showReduceDosagePopup} centered animation={true} scrollable={true} size="md">
                    <Modal.Header closeButton onClick={() => closePreviewModal()}>
                        <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">Reduce Dosage Protocol</h3></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container fluid>
                            <Row>
                                <Col lg="12">
                                    <Form.Group>
                                        <Form.Label>Adverse Event</Form.Label>
                                        <Form.Control as="select" id="" name='reduceDosageReport' value={this.state.reduceDosageReport} onChange={this.handleChange}>
                                            <option value="DEFAULT">- Select Adverse Event -</option>
                                            {
                                                reportParameterArr.map((item, i) => {
                                                        return (
                                                            <option key={item.id} value={item.id}>{`${item.name}`}</option>
                                                        );
                                                    })
                                                }
                                        </Form.Control>
                                    </Form.Group>
                                    {/* <div className="invalid-feedback">{this.state.protocol["chemoMedicine"]}</div> */}
                                </Col>
                                <Col lg='12'>
                                    <Form.Group>
                                        <Form.Label>Chemo Medicine</Form.Label>
                                        <Form.Control as="select" id="" name='reduceDosageChemo' value={this.state.chemoMedicineDosageId} onChange={this.handleChange}>
                                            <option value="DEFAULT">- Select Chemo Medicine -</option> 
                                                { 
                                                    chemoMedicineDosageListArr.map((item, i) => {
                                                        return (
                                                            <option key={item.chemoMedicineId} value={item.chemoMedicineId}>{`${item.chemoMedicineName}`}</option>
                                                        );
                                                    })
                                                }
                                        </Form.Control>
                                        {/* <div className="invalid-feedback">{this.state.protocol["dosageMethod"]}</div> */}
                                    </Form.Group>
                                </Col> 
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer className='text-center'>
                        <Button className="btn btn-secondary" onClick={this.saveReduceDosage.bind(this)}>
                            {this.state.saveLoader && (
                                <Spinner className='mr-2' animation='border' size='1.5rem' />
                            )}
                            Add 
                        </Button>
                        <Button variant="outline-danger" onClick={() => closePreviewModal()}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}